import React, { useMemo } from "react";
import { View, Text, Image } from "@react-pdf/renderer";
import { makePdfStyleSheet } from "./styles";
import { makeImageSrcObject } from "./util";
import logoOctopus from "assets/images/logo-horizontal.png";
export interface PDFHeaderProps {
  logo: string;
  title: string;
  tenant: string;
  subTitle?: string;
  dataEmissao?: string;
  fixed?: boolean;
  cards?: {
    title: string;
    value: string;
    alignItems?: "flex-start" | "center" | "flex-end";
    shouldHide?: boolean;
  }[];
  topRightAdmLogo?: boolean;
  styles?: Record<string, any>;
}

function PDFHeader({
  logo,
  title,
  tenant,
  subTitle,
  fixed,
  cards,
  styles,
  topRightAdmLogo,
  dataEmissao,
}: PDFHeaderProps) {
  const _styles = useMemo(
    () =>
      styles ? { ...makePdfStyleSheet(), ...styles } : makePdfStyleSheet(),
    [styles]
  );

  const _cards = cards?.filter((c) => !c.shouldHide);

  return (
    <>
      <View style={_styles.header} fixed={fixed}>
        <View style={_styles.flexRow}>
          <Image src={makeImageSrcObject(logo)} style={_styles.logo} />

          <View style={_styles.headerDescription}>
            <Text style={_styles.title}>{title}</Text>
            <Text style={_styles.tenantNome}>{tenant}</Text>
            {dataEmissao ? (
              <Text style={_styles.subTitle}>{dataEmissao}</Text>
            ) : null}
            {subTitle ? <Text style={_styles.subTitle}>{subTitle}</Text> : null}
          </View>

          {topRightAdmLogo ? (
            <Image src={logoOctopus} style={_styles.topRightLogo} />
          ) : null}

          {_cards?.length ? (
            <View
              style={{
                ..._styles.headerCardsContainer,
                flex: _cards.length * 0.375,
              }}
            >
              {_cards.map((card, index) => (
                <View
                  key={index}
                  style={
                    makePdfStyleSheet({
                      headerCard: {
                        firstItem: index === 0,
                        lastItem: index === _cards.length - 1,
                        alignItems: card.alignItems,
                      },
                    }).headerCard
                  }
                >
                  <Text>{card.title}</Text>
                  <Text style={_styles.headerCardValue}>{card.value}</Text>
                </View>
              ))}
            </View>
          ) : null}
        </View>
      </View>
      {fixed && (
        <View
          fixed
          render={({ pageNumber }) => {
            if (pageNumber === 1) {
              return null;
            } else {
              return (
                <View
                  style={{
                    height: 16,
                    width: "100%",
                  }}
                />
              );
            }
          }}
        />
      )}
    </>
  );
}

export default PDFHeader;
